import Checkbox from './Checkbox';
import Group from './Group';

Checkbox.Group = Group;
export default Checkbox;



// WEBPACK FOOTER //
// ./components/checkbox/index.tsx